var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSwtNavi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#dc257d;}.cls-3{fill:#007fb7;}.cls-4{fill:#acc911;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_116",
    "data-name": "Gruppe 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_768",
    "data-name": "Pfad 768",
    className: "cls-1",
    d: "M34.5,0A34.5,34.5,0,1,1,0,34.5,34.5,34.5,0,0,1,34.5,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_115",
    "data-name": "Gruppe 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_578",
    "data-name": "Pfad 578",
    className: "cls-1",
    d: "M12.38,18.05V29.73l39-1.79V19.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_579",
    "data-name": "Pfad 579",
    className: "cls-2",
    d: "M12.38,18.05V29.73l39-1.79V19.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_114",
    "data-name": "Gruppe 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_580",
    "data-name": "Pfad 580",
    className: "cls-3",
    d: "M16,51.2l39-1.34V41L16,39.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_581",
    "data-name": "Pfad 581",
    className: "cls-4",
    d: "M20.63,30.17v8.64l39,1.52v-12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_76",
    "data-name": "Rechteck 76",
    className: "cls-5",
    x: 12.38,
    y: 18.05,
    width: 47.21,
    height: 33.15
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSwtNavi);
export default __webpack_public_path__ + "static/media/logo_swt_navi.cec3271b311a66a29f4380f2dc3e6362.svg";
export { ForwardRef as ReactComponent };